import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
const FXM_API_URL = config.servers.fxm.url;
export interface FileDownloadDto {
  uuid: string;
}
interface FileDownloadApi {
  prepareDownload(approvalNo: string, fileUuid: string): Promise<FileDownloadDto>;
}
class FileDownloadServerApi implements FileDownloadApi {
  async prepareDownload(approvalNo: string, fileUuid: string): Promise<FileDownloadDto> {
    const resp = await axios.post<FileDownloadDto>(
      `${FXM_API_URL}/api/download/prepare/mobile/${approvalNo}/${fileUuid}`
    );
    return resp.data;
  }
}
const fileDownloadApi = new FileDownloadServerApi();
export default fileDownloadApi;
